export default __webpack_public_path__ + "stroke-width-6.asset.a973d0bbbcaee92a4e7c894681aeb481.svg";